import { clearSelected } from '../store/conversationGrid';
import { useAppDispatch } from '../store/hooks';

interface HOCProps {
    onDoneHandler: () => void;
}

/**
 * withGridMassAction
 *
 * @description
 * A Higher Order Component which wraps components that contain the logic to execute a mass action
 * from the ConversationGrid component. Extends the passed-in onDoneHandler prop by adding an
 * intermediary step that runs cleanup if the process ended successfully.
 */
export default function withGridMassAction<P extends HOCProps>(
    Component: (props: P) => JSX.Element,
) {
    return function WithGridMassAction({ onDoneHandler, ...props }: P) {
        const dispatch = useAppDispatch();

        const handleStateCleanup = (result?: boolean) => {
            if (result) {
                dispatch(clearSelected());
            }

            onDoneHandler();
        };

        return <Component {...(props as P)} onDoneHandler={handleStateCleanup} />;
    };
}
